




































import { Vue, Component, Prop } from 'vue-property-decorator';

interface IJournalDataItem {
    status: string; 
    comment: string;
    name: string;
    created_at: Date; 
}

type IJournalData = IJournalDataItem[]; 

@Component
export default class ChangelogModal extends Vue {
  @Prop({ default: null }) journalData!: IJournalData | null; 

  get formattedJournalData() {
    if (!this.journalData) return [];

    const months = [
      'января', 'февраля', 'марта', 'апреля',
      'мая', 'июня', 'июля', 'августа',
      'сентября', 'октября', 'ноября', 'декабря'
    ];

    return this.journalData.map(item => {
      const date = new Date(item.created_at);

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      const time = date.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });

      return {
        ...item,
        formattedDate: `${day} ${month} ${year} г. в ${time}`
      };
    });
  }

  show() {
    (this.$refs.changelogModal as any).show();
  }

  hide() {
    (this.$refs.changelogModal as any).hide();
  }
}
